import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { formatPrice } from "../lib/api";
import { Card } from "../components/ui/card";
import { HelpCircle } from "lucide-react";
import { Seo, breadcrumb } from "../lib/seo";

export default function Faq() {
  const { settings } = useSettings();
  const shipCost = settings?.shipping_cost ?? 6;
  const freeThr = settings?.free_shipping_threshold ?? 60;
  const dmin = settings?.delivery_days_min ?? 2;
  const dmax = settings?.delivery_days_max ?? 5;

  const faq = [
    { q: "Come posso effettuare un ordine?", a: "Sfoglia il catalogo, aggiungi i prodotti al carrello e completa l'ordine come ospite, senza registrazione. Ti basta inserire i dati di spedizione e procedere al pagamento." },
    { q: "Come posso pagare?", a: "Il pagamento avviene online tramite checkout protetto Stripe, con carta. I dati della carta non vengono memorizzati sul nostro sito." },
    { q: "Quali sono i costi di spedizione?", a: `La spedizione ha un costo di ${formatPrice(shipCost)} ed è gratuita per ordini pari o superiori a ${formatPrice(freeThr)}.` },
    { q: "Quali sono i tempi di consegna?", a: `La consegna è prevista in ${dmin}-${dmax} giorni lavorativi dal buon esito del pagamento, secondo le modalità indicate al checkout.` },
    { q: "Come posso contattare il distributore?", a: "Puoi inviare una richiesta tramite il modulo nella pagina \"Contatta il distributore\". Ti risponderemo all'indirizzo email che indichi nel modulo." },
    { q: "Ho una domanda su un prodotto: cosa posso fare?", a: "Consulta la scheda del prodotto per descrizione, formato e informazioni disponibili. Per ulteriori domande usa il modulo di contatto del distributore." },
    { q: "Come posso verificare le condizioni di acquisto?", a: "Le condizioni di vendita sono riportate nella pagina Termini e Condizioni; l'informativa sul trattamento dei dati è nella pagina Privacy." },
    { q: "Come posso richiedere assistenza per un ordine?", a: "Per assistenza su un ordine invia una richiesta tramite la pagina \"Contatta il distributore\" indicando i tuoi riferimenti." },
  ];

  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };
  const crumb = breadcrumb([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]);

  return (
    <div className="mx-auto max-w-3xl px-6 py-14" data-testid="faq-page">
      <Seo
        title="Domande frequenti (FAQ) | Herbalife Rossano"
        description="Risposte alle domande frequenti su ordini, pagamenti, costi di spedizione, tempi di consegna e assistenza per l'acquisto online di prodotti Herbalife."
        canonical="/faq"
        jsonLd={[faqLd, crumb]}
      />
      <h1 className="text-3xl sm:text-4xl font-extrabold font-display text-slate-900 flex items-center gap-3"><HelpCircle className="w-8 h-8 text-emerald-600" /> Domande frequenti</h1>
      <div className="mt-8 space-y-4">
        {faq.map((f, i) => (
          <Card key={i} className="p-5 rounded-2xl border-slate-200" data-testid={`faq-item-${i}`}>
            <h2 className="font-semibold text-slate-900">{f.q}</h2>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.a}</p>
          </Card>
        ))}
      </div>
      <p className="mt-8 text-slate-600">Non hai trovato la risposta? <Link to="/contatta-il-distributore" className="text-primary hover:underline font-medium">Contatta il distributore</Link>.</p>
    </div>
  );
}
